<template>
  <PBtn :class="{ expanded: expanded }" dense flat fluid rounded>
    <CollapseVerticalIcon
      v-if="expanded"
      :class="[$props.dense ? 'icon--sm' : 'icon']"
    />
    <ExpandVerticalIcon v-else :class="[$props.dense ? 'icon--sm' : 'icon']" />
  </PBtn>
</template>

<script setup>
import ExpandVerticalIcon from "assets/icons/expand-vertical.svg";
import CollapseVerticalIcon from "assets/icons/collapse-vertical.svg";

defineProps({
  dense: {
    type: Boolean,
    default: false,
  },
  expanded: {
    type: Boolean,
    default: false,
  },
});
</script>
